import { AxisId } from 'ff/debrief/models';

export { default as AxisSelectField } from './AxisSelectField';
export { default as AxisSelectForm } from './AxisSelectForm';

export const axisLabel: { [key in AxisId]: string } = {
    above_ground_level: 'Altitude (AGL)',
    airspeed: 'Airspeed (IAS)',
    altitude: 'Altitude (MSL)',
    bank: 'Bank',
    g_load: 'G Load',
    ground_speed: 'Ground Speed',
    pitch: 'Pitch',
    terrain_elevation: 'Terrain',
};

export const axisConfig: { [key in AxisId]: { label: string; color: string } } =
    {
        above_ground_level: { label: 'Altitude (AGL)', color: '#ffeb0f' },
        airspeed: { label: 'Airspeed (IAS)', color: '#4ec396' },
        altitude: { label: 'Altitude (MSL)', color: '#0F75FF' },
        bank: { label: 'Bank', color: '#ff870f' },
        g_load: { label: 'G Load', color: '#c30fff' },
        ground_speed: { label: 'Ground Speed', color: '#7BC34E' },
        pitch: { label: 'Pitch', color: '#c34e4e' },
        terrain_elevation: { label: 'Terrain', color: '#BA7B19' },
    };
